import { render, staticRenderFns } from "./TotalDisplay.vue?vue&type=template&id=56cb72ea"
import script from "./TotalDisplay.vue?vue&type=script&lang=js"
export * from "./TotalDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports